import Symbol from "./Symbol";
import { INSPECTOR_UPS } from "../../../constants/inspectorConstants";

class Ups extends Symbol {
    constructor({ alias, svgSrc, label, rotable, handles, name}) {
        super("Ups", { alias, svgSrc, label, rotable, handles, name });

        this.attributes = {
            ...this.attributes,
            brand: { isVisible: false, value: null, label: "Marca" },
            model: { isVisible: false, value: null, label: "Modelo" },
            power: { isVisible: false, value: null, label: "Potencia" },
            powerFactor: { isVisible: false, value: null, label: "Factor de Potencia" },
            ratedVoltage: { isVisible: false, value: null, label: "Voltaje nominal" },
            ratedCurrent: { isVisible: false, value: null, label: "Corriente Nominal" },
        };                
    }

    getInspector() {
        return INSPECTOR_UPS;
    }
}

export default Ups;
